import { Layout, LayoutProps } from "antd";
import { FC } from "react";

export type IncLayoutProps = LayoutProps;

export const IncLayout: FC<IncLayoutProps> = (props) => <Layout {...props} />;
